<template>
  <div class="main">
    <div v-if="checkingCode" class="code-checking">
      <van-loading color="#2c64d4" size="36px" vertical>链接验证中...</van-loading>
    </div>
    <template v-if="pageReady">
      <van-nav-bar title="个人信息录入" />
      <van-form @submit="onSubmit" :submit-on-enter="false" validate-first>
      <van-field input-align="right" v-model.trim="userInfo.name" label="证件姓名" placeholder="请输入证件姓名"
        :rules="[
          { required: true, message: '请输入证件姓名', trigger: 'onSubmit' },
          { validator: rulesName, message: '请输入2-20位中文姓名', trigger: 'onBlur' }
        ]" maxlength="20" />
      <van-field input-align="right" disabled label="证件类型" placeholder="二代身份证" />
      <van-field input-align="right" v-model.trim="userInfo.idcard" label="证件号码" placeholder="请输入证件号码"
        :rules="[
          { required: true, message: '请输入证件号码', trigger: 'onSubmit' },
          { validator: rulesId, message: '请输入正确的18位身份证号码', trigger: 'onBlur' }
        ]" maxlength="18" />
      <van-field input-align="right" v-model.trim="userInfo.company" label="单位名称" placeholder="请输入单位名称"
        :rules="[
          { required: true, message: '请输入单位名称', trigger: 'onSubmit' },
          { validator: rulesCompany, message: '单位名称应为2-35个字符', trigger: 'onBlur' }
        ]" maxlength="35" />
      <van-field input-align="right" v-model.trim="userInfo.address" label="现居地址" placeholder="请输入现居地址"
        :rules="[
          { required: true, message: '请输入现居地址', trigger: 'onSubmit' },
          { validator: rulesAddress, message: '现居地址应为5-35个字符', trigger: 'onBlur' }
        ]" maxlength="35" />
      <van-field input-align="right" type="tel" v-model.trim="userInfo.bank" label="到账银行卡" placeholder="请输入到账银行卡"
        :rules="[
          { required: true, message: '请输入到账银行卡', trigger: 'onSubmit' },
          { validator: rulesBank, message: '请输入12-19位银行卡号码', trigger: 'onBlur' }
        ]" maxlength="19" />
      <van-field input-align="right" type="tel" v-model.trim="userInfo.phone" label="手机号码" placeholder="请输入手机号码"
        :rules="[
          { required: true, message: '请输入手机号码', trigger: 'onSubmit' },
          { validator: rulesIphone, message: '请输入正确的手机号码', trigger: 'onBlur' }
        ]" maxlength="11" />
        <van-button round block type="info" native-type="submit">提交申请</van-button>
      </van-form>
      <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
          <van-loading color="#0094ff">申请中...</van-loading>
        </div>
      </van-overlay>
    </template>
    <van-dialog
      :value="accessDenied"
      :message="accessMessage"
      overlay-class="access-denied-overlay"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="false"
      :close-on-popstate="false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        name: '',
        idcard: '',
        company: '',
        address: '',
        bank: '',
        phone: '',
        code: ''
      },
      showOverlay: false,
      checkingCode: true,
      pageReady: false,
      accessDenied: false,
      accessMessage: '非法访问'
    }
  },
  mounted() {
    const code = this.GetQueryString('code').trim();
    this.userInfo.code = code;

    if (!code) {
      this.denyAccess('非法访问');
      this.checkingCode = false;
      return;
    }

    this.verifyCode(code);
  },
  methods: {
    verifyCode(code) {
      this.api.code_verify({ code })
        .then(res => {
          if (Number(res.code) === 200) {
            window.localStorage.setItem('code', code);
            this.pageReady = true;
            return;
          }

          this.denyAccess('链接失效');
        })
        .catch(() => {
          this.denyAccess('链接验证失败，请刷新页面重试');
        })
        .finally(() => {
          this.checkingCode = false;
        });
    },
    denyAccess(message) {
      window.localStorage.removeItem('code');
      this.pageReady = false;
      this.accessMessage = message;
      this.accessDenied = true;
    },
    rulesName(val) {
      if (!val) return true;
      let res = /^[\u4e00-\u9fa5·]{2,20}$/;
      return res.test(val);
    },
    rulesId(val) {
      if (!val) return true;
      const idcard = val.toUpperCase();
      const format = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
      if (!format.test(idcard)) return false;

      const birthday = idcard.slice(6, 14);
      const date = new Date(`${birthday.slice(0, 4)}-${birthday.slice(4, 6)}-${birthday.slice(6, 8)}T00:00:00`);
      if (Number.isNaN(date.getTime()) || date.getFullYear() !== Number(birthday.slice(0, 4)) ||
        date.getMonth() + 1 !== Number(birthday.slice(4, 6)) || date.getDate() !== Number(birthday.slice(6, 8))) {
        return false;
      }

      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checks = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      const sum = weights.reduce((total, weight, index) => total + Number(idcard[index]) * weight, 0);
      return checks[sum % 11] === idcard[17];
    },
    rulesCompany(val) {
      if (!val) return true;
      return val.trim().length >= 2 && val.trim().length <= 35;
    },
    rulesAddress(val) {
      if (!val) return true;
      return val.trim().length >= 5 && val.trim().length <= 35;
    },
    rulesBank(val) {
      if (!val) return true;
      return /^[1-9]\d{11,18}$/.test(val);
    },
    rulesIphone(val) {
      if (!val) return true;
      let res = /^1[3-9]\d{9}$/;
      return res.test(val);
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
        context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    onSubmit() {
      if (!this.pageReady || !this.userInfo.code) {
        this.denyAccess('非法访问');
        return;
      }

      this.showOverlay = true
      this.api.loan_one(this.userInfo)
        .then(res => {
          if (res.code == 200) {
            setTimeout(() => {
              this.showOverlay = false
              this.$toast({
                type: 'success',
                message: res.msg || '提交成功',
                onClose: () => {
                  window.localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                  this.$router.push('/rulestep/setp1')
                }
              })
            }, 1200);
          } else {
            window.localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
            this.showOverlay = false
            this.$toast.fail(res.msg);
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.code-checking {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
</style>
